import React, { Component } from 'react';
import { Modal } from 'reactstrap';

export const modalWrapper = (isDefaultDisplay, modalName) => (WrappedComponent) => {
  class FDModalContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        modal: isDefaultDisplay,
        modalOptions: {
          title: 'Alert',
          modalType: 'confirmModal',
          content: '',
          confirmBtnText: 'Confirm',
          okAlertBtnTxt: 'Ok',
          cancelBtnText: 'Cancel'
        }
      };
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
    }

    open() {
      this.setState({ modal: true });
    }

    close() {
      this.setState({ modal: false });
    }

    showModal = e => {
      this.setState({
        modalOptions: { ...this.state.modalOptions, ...e.detail },
        modal: true
      });
    }

    componentDidMount() {
      document.body.addEventListener(modalName, this.showModal);
    }

    componentWillUnmount() {
      document.body.removeEventListener(modalName, this.showModal);
    }

    render() {
      const widhtClass = this.props.modalClassName ? this.props.modalClassName : 'custom-otp-popup';
      const wrapperClassName = this.props.wrapperClassName ? this.props.wrapperClassName : ''
      return (
        <Modal backdrop='static' modalClassName={wrapperClassName} isOpen={this.state.modal} toggle={this.close} fade={false} className={`${widhtClass} modal-dialog-centered`} keyboard={false}>
          <WrappedComponent {...this.props} closeModal={this.close} />
        </Modal>
      );
    }
  }
  return FDModalContainer
}